(ns frontend.view.nev.zap-vault.event
  (:require [common.localization :as loc]
            [common.util :as cu]
            [frontend.controller.websocket.event :as ws]
            [frontend.exports.excel :as excel]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.utils :as fu]
            [frontend.view.components.clipboard :as clipboard]
            [frontend.view.nev.zap-vault.model :as model]
            [fx.ajax :as ajax]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [ui.util :as uu]))

(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ vault-id tab]]
   {:db (-> db
            (assoc-in model/active-tab-full-path (get model/all-tabs tab model/tab-documents))
            (assoc-in model/vault-id-full-path vault-id))
    :fx [[:dispatch [::load-activities vault-id]]]}))

(rf/reg-event-fx
 ::load-activities-ok
 (fn [{db :db} [_ resp]]
   (js/console.log "Activities : " (:body resp))
   {:db (-> db
            (assoc-in model/activities-full-path (:body resp)))}))

(rf/reg-event-fx
 ::load-activities-failed
 (fn [{db :db} [_ resp]]
   (js/console.warn "Failed to load activities " resp)
   {:db db}))

(rf/reg-event-fx
 ::load-activities
 (fn [{_db :db} [_ vault-id]]
   {::ws/send {:id         :vault-usage/get-activities
               :body       {:vault-id vault-id}
               :on-success [::load-activities-ok]
               :on-error   [::load-activities-failed]}}))

(rf/reg-event-fx
 ::export-activities-as-excel
 (fn [{db :db} _]
   (let [vault-id (get-in db model/vault-id-full-path)
         vault-name (->> vault-id
                         (session/get-entity)
                         :zap-vault/name)
         file-name (str vault-name " activities.xlsx")
         activities-data [(concat [[(loc/tr :vault-activities-export-sheet-name)]]
                                  [[(loc/tr :vault-usage/email)
                                    (loc/tr :vault-usage/type)
                                    (loc/tr :vault-usage/filename)
                                    (loc/tr :common/created-on)]]
                                  (->> (get-in db model/activities-full-path)
                                       (map (fn [vault-usage]
                                              [(:vault-usage/email vault-usage)
                                               (loc/tr (:vault-usage/type vault-usage))
                                               (:vault-usage/filename vault-usage)
                                               (uu/display-date-timestamp nil (:common/created-on vault-usage))]))
                                       (vec)))]]
     (excel/export-multiple-sheet-array-data file-name activities-data)
     {:db (-> db)})))

(rf/reg-event-fx
 ::set-active-tab
 (fn [{db :db} [_ tab]]
   (let [vault-id (get-in db model/vault-id-full-path)]
     {:db                   (-> db
                                (potpuri/dissoc-in model/root-path)
                                (assoc-in model/active-tab-full-path tab))
      ::routing/old-routing {:path-args [:entity.type/zap-vault :id vault-id :tab tab]}})))

(rf/reg-event-fx
 ::update-ok
 (fn [{db :db} [_ entity-id attribute]]
   {:db (-> db
            (potpuri/dissoc-in (into model/optimistic-updates-full-path [entity-id attribute])))}))

(rf/reg-event-fx
 ::update-failed
 (fn [{db :db} [_ entity-id attribute value resp]]
   (js/console.warn "Failed to update entity " entity-id " " attribute " " value " >>> " resp)
   {:db (-> db
            (potpuri/dissoc-in (into model/optimistic-updates-full-path [entity-id attribute])))}))

(rf/reg-event-fx
 ::send-update
 (fn [{_db :db} [_ entity-id attribute value]]
   {::ws/send {:id         (if (cu/blank-value? value)
                             :entity/remove-attribute
                             :entity/update-attribute)
               :body       {:db/id     entity-id
                            :attribute attribute
                            :value     value}
               :on-success [::update-ok entity-id attribute value]
               :on-error   [::update-failed entity-id attribute value]}}))

(defn new-min-ord
  [min-ord]
  (js/console.log "New min ord : " min-ord " < " (type min-ord))
  (if-not (number? min-ord)
    0.0
    (dec min-ord)))

(rf/reg-event-fx
 ::set-primary-file
 (fn [{db :db} [_ attachment]]
   (let [vault-id (get-in db model/vault-id-full-path)
         vault (session/get-entity vault-id)
         new-ord (->> vault
                      :common/attachments
                      (keep (fn [aid]
                              (let [d (session/get-entity aid)]
                                (js/console.log (:common/ord d) " : " aid " > " (:attachment/filename d))
                                d)))
                      (filter :common/ord)
                      (sort-by :common/ord)
                      (first)
                      :common/ord
                      (new-min-ord))]
     {:db (-> db
              (assoc-in (into model/optimistic-updates-full-path [(:db/id attachment) :common/ord]) new-ord))
      :fx [[:dispatch [::send-update (:db/id attachment) :common/ord new-ord]]]})))

(rf/reg-event-fx
 ::remove-file
 (fn [{db :db} [_ attachment]]
   {:db (-> db
            (assoc-in model/delete-attachment-full-path (:db/id attachment)))}))

(rf/reg-event-fx
 ::start-edit-file
 (fn [{db :db} [_ attachment]]
   {:db (-> db
             ;; ensure no changes
            (potpuri/dissoc-in model/document-changes-full-path)
            (assoc-in model/edit-attachment-full-path (:db/id attachment)))}))

(rf/reg-event-fx
 ::edit-document-attribute
 (fn [{db :db} [_ attribute value]]
   {:db (-> db
            (assoc-in (into model/document-changes-full-path [attribute]) value))}))

(rf/reg-event-fx
 ::cancel-file-edit
 (fn [{db :db} _]
   {:db (-> db
            (potpuri/dissoc-in model/edit-attachment-full-path))}))

(rf/reg-event-fx
 ::edit-file!-ok
 (fn [{db :db} [_ _resp]]
   {:db (-> db
            (potpuri/dissoc-in model/saving-edits?-full-path)
            (potpuri/dissoc-in model/document-changes-full-path))}))

(rf/reg-event-fx
 ::edit-file!-failed
 (fn [{db :db} [_ resp]]
   (js/console.log "Failed to delete file : " resp)
   {:db (-> db
            (potpuri/dissoc-in model/saving-edits?-full-path))}))

(rf/reg-event-fx
 ::edit-file!
 (fn [{db :db} [_ file]]
   (let [file-id (:db/id file)
         changes (get-in db model/document-changes-full-path)]
     {:db       (-> db
                    (assoc-in model/saving-edits?-full-path true))
      ::ws/send {:id         :entity/update-attributes
                 :body       {:db/id file-id
                              :data  changes}
                 :on-success [::edit-file!-ok]
                 :on-error   [::edit-file!-failed]}})))

(rf/reg-event-fx
 ::cancel-file-removal
 (fn [{db :db} _]
   {:db (-> db
            (potpuri/dissoc-in model/delete-attachment-full-path))}))

(rf/reg-event-fx
 ::delete-file!-ok
 (fn [{db :db} [_ _resp]]
   {:db (-> db
            (potpuri/dissoc-in model/deleting-attachment?-full-path))}))

(rf/reg-event-fx
 ::delete-file!-failed
 (fn [{db :db} [_ resp]]
   (js/console.log "Failed to delete file : " resp)
   {:db (-> db
            (potpuri/dissoc-in model/deleting-attachment?-full-path))}))

(rf/reg-event-fx
 ::delete-file!
 (fn [{db :db} [_ file]]
   (let [file-id (:db/id file)]
     {:db       (-> db
                    (assoc-in model/deleting-attachment?-full-path true))
      ::ws/send {:id         :entity/disable!
                 :body       {:entity-id file-id}
                 :on-success [::delete-file!-ok]
                 :on-error   [::delete-file!-failed]}})))

(rf/reg-event-fx
 ::config-change
 (fn [{db :db} [_ attribute value]]
   {:db (-> db
            (assoc-in (into model/config-changes-full-path [attribute]) value))}))

(rf/reg-event-fx
 ::vault-change
 (fn [{db :db} [_ attribute value]]
   {:db (-> db
            (assoc-in (into model/vault-changes-full-path [attribute]) value))}))

(rf/reg-event-fx
 ::preview-disclaimer
 (fn [{db :db} _]
   {:db (-> db
            (assoc-in model/preview?-full-path true))}))

(rf/reg-event-fx
 ::set-preview-confirmed?
 (fn [{db :db} _]
   {:db (-> db
            (assoc-in model/preview-confirmed?-full-path true))}))

(rf/reg-event-fx
 ::close-preview!
 (fn [{db :db} _]
   {:db (-> db
            (assoc-in model/preview?-full-path false)
            (assoc-in model/preview-confirmed?-full-path false))}))

(rf/reg-event-fx
 ::cancel-changes
 (fn [{db :db} _]
   {:db (-> db
            (potpuri/dissoc-in model/config-changes-full-path)
            (potpuri/dissoc-in model/vault-changes-full-path))}))

(rf/reg-event-fx
 ::save-changes-ok
 (fn [{db :db} [_ _changes]]
   {:db (-> db
            (potpuri/dissoc-in model/config-changes-full-path)
            (potpuri/dissoc-in model/vault-changes-full-path))}))

(rf/reg-event-fx
 ::save-changes-failed
 (fn [{db :db} [_ entity-id attribute value resp]]
   (js/console.warn "Failed to update entity " entity-id " " attribute " " value " >>> " resp)
   {:db (-> db
            (potpuri/dissoc-in (into model/optimistic-updates-full-path [entity-id attribute])))}))

(rf/reg-event-fx
 ::save-changes
 (fn [{db :db} [_ changes]]
   {:db       (-> db
                  (assoc-in model/processing?-full-path true))
    ::ajax/send {:operation :zap-vault/save-changes!
                 :body       changes
                 :on-ok     [::save-changes-ok changes]
                 :on-error   [::save-changes-failed]}}))

(rf/reg-event-fx
 ::copy-link-to-clipboard
 (fn [{db :db} _]
   (let [vault-id (get-in db model/vault-id-full-path)
         vault (session/get-entity vault-id)
          ;; TODO:  refactor as reframe db get
         tenant @session/tenant]
      ;; TODO : refactor as fx
     (clipboard/copy-to (str (if (session/dev?)
                               "http://" "https://")
                             (:tenant/vault-domain tenant)
                             (when (session/dev?)
                               ":3000")
                             "?vault-token=" (:zap-vault/unique-id vault)))
     {})))

(rf/reg-event-fx
 ::toggle-archived
 (fn [{db :db} [_ vault]]
   (let [entity-id (:db/id vault)
         attribute :common/archived?
         value (not (:common/archived? vault))]
     {:db       (-> db
                    (assoc-in model/processing?-full-path true))
      ::ws/send {:id         :entity/update-attribute
                 :body       {:db/id             (:db/id vault)
                              :attribute         :common/archived?
                              :value             (not (:common/archived? vault))
                              :instant-indexing? true}
                 :on-success [::update-ok entity-id attribute value]
                 :on-error   [::update-failed entity-id attribute value]}})))

(rf/reg-event-fx
 ::upload-logo
 (fn [{db :db} [_ base64]]
   (when-not (cu/blank-value? base64)
     {:db       (assoc-in db model/uploading-logo-full-path true)
      ::ws/send {:id         :image-utils/upload-base64
                 :body       {:data base64}
                 :on-success [::upload-ok base64]
                 :on-error   [::upload-failed base64]}})))

(rf/reg-event-fx
 ::upload-ok
 (fn [{db :db} [_ _base64-image resp]]
   (let [url (:url (:body resp))]
     (js/console.log "Logo upload successful:" resp " > " url)
     {:db (-> db
               ;; Remove uploading state
              (potpuri/dissoc-in model/uploading-logo-full-path))
      :fx [[:dispatch [::config-change :vault-config/vault-logo url]]]})))

(rf/reg-event-fx
 ::upload-failed
 (fn [{db :db} [_ _base64-image error resp]]
   (js/console.error "Logo upload failed:" error resp)
   {:db (-> db
             ;; Remove uploading state
            (potpuri/dissoc-in model/uploading-logo-full-path)
             ;; Optionally store error state
            )
     ;; Show user-friendly error message
     ;; TODO: UI messages
    #_:fx #_[[:dispatch [:ui/show-notification
                         {:type    :error
                          :title   "Upload Failed"
                          :message "Failed to upload logo. Please try again."}]]]}))

(rf/reg-event-fx
 ::open-file
 (fn [{db :db} [_ id]]
   (js/console.log "Download : " id)
   (fu/open-attachment! id)
   {:db (-> db)}))
